import { Directive, OnDestroy, OnInit } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

import { Authorizer } from './authorizer';

@Directive()
export abstract class AuthorizeBase implements OnInit, OnDestroy {
  protected isAuthorized = false;

  protected readonly _subscriptions: Subscription[] = [];

  constructor(private authorizers: Authorizer[]) {}

  ngOnInit() {
    if (this.authorizers == null || this.authorizers.length === 0) {
      throw new Error('No authorizers provided');
    }

    this.authorizers.sort((a, b) => a.order - b.order);
    this._subscriptions.push(
      combineLatest(
        this.authorizers.map(a =>
          a.isAuthorizedChanges.pipe(map(isAuthorized => ({ authorizer: a, isAuthorized }))),
        ),
      )
        .pipe(
          // Get the first unauthorized result
          map(results => results.find(({ isAuthorized }) => !isAuthorized)),
          distinctUntilChanged(),
        )
        .subscribe(result => {
          this.authorizers.forEach(authorizer => {
            authorizer.toggleActive?.(authorizer === result?.authorizer);
          });

          const isAuthorized = result == null;

          this.isAuthorized = isAuthorized;
          this.toggleAuthorized(isAuthorized);
        }),
    );
  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  protected abstract toggleAuthorized(this: this, isAuthorized: boolean);

  protected handleClick?(this: this);
}
